exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trip-history-main-panel{width:100%;top:104px;position:absolute}.loading-history{width:100px;position:absolute;left:50%}.active-booking-status{color:green}.multi-stop-text{color:var(--primary-brand-colour)}", ""]);

// exports
